(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size_chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart')) {
    class SizeChart extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.baseUnit = this.dataset.baseUnit;

        this.querySelector('[data-open]').addEventListener('click', () => {
          this.showTab('chart');
          this.dialog.showModal();
        });
        this.querySelectorAll('[data-close]').forEach((btn) =>
          btn.addEventListener('click', () => this.dialog.close())
        );
        // A click on the dialog element itself means the backdrop was clicked
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.querySelectorAll('[data-unit]').forEach((btn) =>
          btn.addEventListener('click', () => this.setUnit(btn.dataset.unit))
        );
        this.querySelectorAll('[data-tab]').forEach((tab) =>
          tab.addEventListener('click', () => this.showTab(tab.dataset.tab))
        );

        this.setUnit(this.dataset.defaultUnit || this.baseUnit);
      }

      setUnit(unit) {
        this.querySelectorAll('[data-measure]').forEach((cell) => {
          const original = cell.dataset.measure;
          cell.textContent = unit === this.baseUnit ? original : this.convert(original, unit);
        });
        this.querySelectorAll('[data-unit]').forEach((btn) =>
          btn.setAttribute('aria-pressed', btn.dataset.unit === unit)
        );
      }

      // Converts every number in a cell, so ranges like "81-84" work too
      convert(text, toUnit) {
        const factor = toUnit === 'in' ? 1 / 2.54 : 2.54;
        return text.replace(/\d+(\.\d+)?/g, (n) => String(Math.round(parseFloat(n) * factor * 10) / 10));
      }

      showTab(name) {
        this.querySelectorAll('[data-tab]').forEach((tab) =>
          tab.setAttribute('aria-selected', tab.dataset.tab === name)
        );
        this.querySelectorAll('[data-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.panel !== name;
        });
      }
    }
    customElements.define('size-chart', SizeChart);
  }
  } catch(e) { console.error(e); }
})();

})();
